import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const SvgContainer = styled.span`
  display: inline-flex;
  align-items: center;
`

const Svg = styled.svg`
  width: 3rem;
  height: 3rem;
  position: relative;
  top: ${props => props.baseline ? '-1.1rem' : '0'};
`

export const ChevronR = (props) => (
  <SvgContainer>
    <Svg width={20} height={20} viewBox="0 0 20 20" {...props}>
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        d="M8 5l5 5-5 5"
      />
    </Svg>
  </SvgContainer>
)

ChevronR.propTypes = {
  baseline: PropTypes.bool
}